import { render, staticRenderFns } from "./MyMissions.vue?vue&type=template&id=2d96aaf0&"
import script from "./MyMissions.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MyMissions.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports